import styles from "../../assets/styles/Wallet/Wallet.module.scss";
import React, { useMemo, useState } from "react";
import {
  AppPage,
  BusinessInsightComponent as BIC,
  PageLoader,
  MimaButton,
  MimaTable,
  MimaNewFilter,
} from "../../components";
import { AnimatePresence } from "framer-motion";
import { amountFormatter } from "../../utils/utils";
import { BsFillArrowDownSquareFill } from "react-icons/bs";
import moment from "moment";
import constant from "../../utils/constant";
import { MimaToastUtil } from "../../components";
import { AccountStatementContainer } from "../../containers/WalletContainer";
import { walletStore } from "../../stores";
import { downloadXlsx2 } from "../../utils/download";
import BlockFundsModal from "./BlockFundsModal";

const WalletTransactions = ({
  loading,
  selectedBusiness,
  selectedBusinessWallet,
  isLoading,
  data,
  isFetching,
  limit,
  onLimitChange,
  setSearchQuery,
  currentPage,
  setCurrentPage,
  setCurrencyCode,
  refetch,
  filterHandler,
}) => {
  const [openModal, setOpenModal] = useState("");
  const [curr, setCurr] = useState("NGN");
  const [showFilter, setShowFilter] = useState(false);

  const wallet = ["NGN", "USD", "EUR", "GBP"];

  const openModalHandler = (modal) => {
    setOpenModal(modal);
  };
  const closeModal = () => {
    setOpenModal("");
  };

  const modalName = {
    statement: "STATEMENT",
    blockFunds: "BLOCK-FUNDS",
  };

  const tableData = useMemo(() => {
    if (data?.status === constant.Success) {
      return data?.data?.transactions || [];
    }
    return [];
  }, [data]);

  const tableColumns = [
    {
      Header: "Type",
      accessor: "type",
      Cell: ({ cell }) => {
        const type = cell.value;
        return (
          <span
            className={`${styles.type} ${type === "OUTFLOW" ? styles.type__exp : styles.type__inc}`}
          ></span>
        );
      },
    },
    {
      Header: "Date",
      accessor: "createdAt",
      Cell: ({ cell }) => {
        const createdAt = cell.value;
        return <span>{moment(createdAt).format("DD/MM/YY HH:mm")}</span>;
      },
    },
    {
      Header: "Narration",
      accessor: "narration",
      Cell: ({ cell }) => {
        const narration = cell.value;
        return <span>{narration}</span>;
      },
    },
    {
      Header: "Amount",
      accessor: "transactionAmount",
      Cell: ({ cell }) => {
        const currencyCode = cell.row.original.currencyCode;
        const amount = cell.value;
        return <span>{amountFormatter(currencyCode).format(amount)}</span>;
      },
    },
    {
      Header: "Bank",
      accessor: "bankName",
    },
    {
      Header: "Account Number",
      accessor: "receiverAccountNumber",
    },
    {
      Header: "Account Name",
      accessor: "receiverAccountName",
    },
    {
      Header: "Bal After",
      accessor: "walletBalance",
      Cell: ({ cell }) => {
        const currencyCode = cell.row.original.currencyCode;
        const amount = cell.value;
        return <span>{amountFormatter(currencyCode).format(amount)}</span>;
      },
    },
    {
      Header: "Status",
      accessor: "status",
      Cell: ({ cell }) => {
        const status = cell.row.original.status;
        return (
          <span
            className={`status ${status === "PAID" ? "status__green" : status === "UNPAID" ? "status__red" : "status__dark__yellow"}`}
          >
            {status}
          </span>
        );
      },
    },
    {
      Header: "Receipt",
      Cell: ({ cell }) => {
        const status = cell.row.original.status;
        const transfer = cell.row.original.transfer;
        const type = cell.row.original.type;
        const bankName = cell.row.original.bankName;
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              margin: "1rem",
            }}
          >
            {status === "PAID" && type === "OUTFLOW" && bankName !== "" ? (
              <BsFillArrowDownSquareFill
                size="4rem"
                color="blue"
                onClick={async () => {
                  if (transfer === undefined) {
                    // const tranQuery = `business=${selectedBusiness._id}`;
                    // await TransactionsController.getAllTransactions(tranQuery);
                    await refetch();
                    return MimaToastUtil.error({
                      message:
                        "Your receipt is being generated, try again after 60 seconds",
                    });
                  } else {
                    window.open(transfer.transferReceiptUrl);
                    MimaToastUtil.success({
                      message: constant.Success,
                    });
                  }
                }}
              />
            ) : (
              ""
            )}
          </div>
        );
      },
    },
  ];

  const filterByData = [{ value: "Date", key: "createdAt" }];

  const printData = tableData.map((item) => ({
    type: item?.type,
    Date: moment(item.createdAt).format("DD/MM/YY HH:mm"),
    Narration: item?.narration || "",
    Amount: amountFormatter(item.currencyCode).format(item.transactionAmount),
    Bank: item?.bankName || "",
    "Account Number": item?.receiverAccountNumber || "",
    "Account Name": item?.receiverAccountName || "",
    "Balance After": amountFormatter(item.currencyCode).format(
      item.walletBalance
    ),
    Status: item.status,
  }));

  console.log("selectedBusinessWallet", selectedBusinessWallet);

  return (
    <AppPage pageTitle={`${selectedBusiness.tradingName} - (Wallet)`}>
      {loading ? (
        <PageLoader title="While we set things up for you" />
      ) : (
        <>
          <div className={styles.cards}>
            {selectedBusinessWallet?.map((item) => (
              <BIC
                title={`Wallet Balance ${item.currencyCode}`}
                amount={amountFormatter(item.currencyCode).format(
                  item?.balance
                )}
                styleClass={
                  item.currencyCode === "NGN"
                    ? styles.cards__ngn
                    : item.currencyCode === "USD"
                      ? styles.cards__usd
                      : item.currencyCode === "GBP"
                        ? styles.cards__gbp
                        : styles.cards__eur
                }
              />
            ))}
          </div>
          <div className={styles.filterClass}>
            <div>
              <MimaButton
                title={showFilter ? "Close Filter" : "Filter"}
                onClick={() => setShowFilter(!showFilter)}
              />
            </div>
            <MimaButton
              title="Request Account Statement"
              onClick={() => {
                openModalHandler(modalName.statement);
                walletStore.setBusinessId(selectedBusiness._id);
              }}
              width={32}
            />
            <MimaButton
              title={`Download ${curr} Report`}
              width={27}
              onClick={() => {
                downloadXlsx2(printData);
              }}
            />
            <MimaButton
              title={`Block Funds `}
              width={27}
              onClick={() => {
                openModalHandler(modalName.blockFunds);
              }}
              buttonColor={"var(--color-error)"}
            />
          </div>
          <MimaNewFilter
            showFilter={showFilter}
            setShowFilter={setShowFilter}
            filterByData={filterByData}
            filterHandler={filterHandler}
          />

          <div className={styles.main_nav}>
            {wallet?.map((item) => (
              <div
                key={item}
                className={
                  curr === item
                    ? styles.main_nav_item_active
                    : styles.main_nav_item
                }
                onClick={() => {
                  setCurr(item);
                  setCurrencyCode(item);
                }}
              >
                {item} Wallet
              </div>
            ))}
          </div>

          <MimaTable
            tableData={tableData}
            tableColumns={tableColumns}
            searchPlaceholder="Search Subscription"
            searchVariant="wide"
            totalItems={data?.data?.totalCounts}
            onLimitChange={onLimitChange}
            isLoading={isLoading}
            isFetching={isFetching}
            limit={limit}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            setSearchQuery={setSearchQuery}
          />
        </>
      )}
      {openModal !== "" && (
        <div className="modal">
          <AnimatePresence>
            {openModal === modalName.statement && (
              <AccountStatementContainer
                closeModal={closeModal}
                selectedBusiness={selectedBusiness}
              />
            )}
            {openModal === modalName.blockFunds && (
              <BlockFundsModal
                closeModal={closeModal}
                selectedBusinessWallet={selectedBusinessWallet}
                selectedBusiness={selectedBusiness}
              />
            )}
          </AnimatePresence>
        </div>
      )}
    </AppPage>
  );
};

export default WalletTransactions;
